import React from 'react';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import ContributionItem from './ContributionItem';
import { Schema } from '../../../../../amplify/data/resource';
import { SelectionSet } from 'aws-amplify/api';

const fundContributionSelectionSet = [
  'id',
  'contributionType',
  'contributionAmount',
  'contributionRate',
  'exemptPayments',
  'registryIdentifier',
  'previousRegistryIdentifier',
  'status',
  'error',
  'employeeId',
] as const;

// @ts-ignore
type FundContribution = SelectionSet<Schema['FundContribution']['type'], typeof fundContributionSelectionSet>;

interface ContributionsListProps {
  contributions: FundContribution[];
}

const ContributionsList: React.FC<ContributionsListProps> = ({ contributions }) => {
  return (
    <Box sx={{ direction: 'rtl', width: '100%' }}>
      <TableContainer
        component={Paper}
        sx={{
          backgroundColor: 'transparent',
          boxShadow: 'none',
          overflowY: 'auto',
          width: '100%',
        }}
      >
        <Table
          stickyHeader
          sx={{
            backgroundColor: 'transparent',
            borderCollapse: 'separate',
            borderSpacing: '0 10px',
            width: '100%',
            tableLayout: 'fixed',
          }}
        >
          <TableHead>
            <TableRow sx={{ backgroundColor: 'transparent' }}>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: 'transparent',
                  width: '20%',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  רכיב הפרשה
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: 'transparent',
                  width: '15%',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  שכר מדווח
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: 'transparent',
                  width: '15%',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  סך הפרשה
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: 'transparent',
                  width: '15%',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  אחוז הפרשה
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: 'transparent',
                  width: '20%',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  סטטוס רשומה
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: 'transparent',
                  width: '15%',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  סוג שגיאה
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {contributions.map((contribution: FundContribution, index: number) => (
               <ContributionItem key={contribution.id || index} contribution={contribution} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ContributionsList; 